import initialState from './state.js';

export default {
    resetState(state) {
        Object.assign(state, initialState);
    },

    setPayments(state, payments) {
        state.payments = payments;
    },

    addPayment(state, payment) {
        if (state.payments.some(p => p.id === payment.id)) {
            return;
        }

        state.payments.unshift(payment);
    },

    removePayment(state, id) {
        state.payments.splice(state.payments.findIndex(payment => payment.id == id), 1);
    },

    updatePayment(state, updatedPayment) {
        if (!updatedPayment.id) {
            return;
        }

        state.payments
            .filter(payment => payment.id == updatedPayment.id)
            .forEach(payment => Object.assign(payment, updatedPayment));
    },

    updatePagination(state, pagination) {
        state.pagination.from = pagination.from;
        state.pagination.to = pagination.to;
        state.pagination.total = pagination.total;
        state.pagination.lastPage = pagination.lastPage;
    },

    setPaginationPage(state, page) {
        state.pagination.currentPage = page;
    },
};
